"use strict";

module.exports = [
  {
    level: "1",
    value: "HUSB",
    display: "husband",
    immediate: true
  },
  {
    level: "1",
    value: "WIFE",
    display: "wife",
    immediate: true
  },
  {
    level: "3",
    value: "partner",
    display: "partner",
    immediate: false
  },
  {
    level: "4",
    value: "CHILD",
    display: "child",
    immediate: true
  },
  {
    level: "4",
    value: "FTH",
    display: "father",
    immediate: true
  },
  {
    level: "4",
    value: "MTH",
    display: "mother",
    immediate: true
  },
  {
    level: "5",
    value: "GRNDCHILD",
    display: "grandchild",
    immediate: false
  },
  {
    level: "5",
    value: "GRPRN",
    display: "grandparent",
    immediate: false
  },
  {
    level: "5",
    value: "SIB",
    display: "sibling",
    immediate: true
  },
  {
    level: "6",
    value: "EXT",
    display: "extended family",
    immediate: false
  },
  {
    level: "6",
    value: "INLAW",
    display: "inlaw",
    immediate: false
  },
  {
    level: "7",
    value: "caregiver",
    display: "caregiver",
    immediate: false
  },
  {
    level: "7",
    value: "guardian",
    display: "guardian",
    immediate: true
  },
  {
    level: "7",
    value: "ROOM",
    display: "roommate",
    immediate: false
  },
  {
    level: "8",
    value: "friend",
    display: "friend",
    immediate: false
  },
  {
    level: "8",
    value: "NBOR",
    display: "neighbor",
    immediate: false
  }
];
